<template>

  <div :class="`box ${boxCss} ${collapsedClass}`" :id="boxId">
    <div class="box-header with-border" @click="collapsable ? (isCollapsed = !isCollapsed) : null">
      <h3 class="box-title">
        <a :href="titleLink" v-if="titleLink">{{ title }}</a>
        <span v-else>{{ title }}</span>
      </h3>

      <div class="box-tools pull-right">
        <slot  name="tools"></slot>
        <lte-button  :icon="(isCollapsed ? 'caret-down' : 'caret-up')" v-if="collapsable"/>
      </div>
    </div>

    <div class="box-body" :id="contentId">
      <slot></slot>
    </div>
  </div>


</template>

<script>

export default {
  name: 'LteBox',
  props: {
    boxCss: { type: String, default: null },
    boxId: { type: String, default: null },
    contentId: { type: String, default: null },
    title: { type: String, default: null },
    titleLink: { type: String, default: null },
    collapsed: { type: Boolean, default: false },
    collapsable: { type: Boolean, default: true }
  },
  created(){
    this.isCollapsed = this.collapsed
  },
  data(){
    return {
      isCollapsed: false
    }
  },
  computed: {
    collapsedClass(){
      if (this.isCollapsed){
        return 'collapsed-box'
      }else{
        return ''
      }
    }
  },
  methods: {
    unCollapse(){
      this.isCollapsed = false
    }
  }
}

</script>